import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, map, filter, includes, size } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";
import DashboardDoughnut from "../DashboardDoughnut";
import DoughnutLegend from "../DoughnutLegend";

import { calculatePercentage } from "../../../utils/data";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  doughnutContainer: {
    margin: "0px 20px",
    display: "flex",
    alignItems: "center",
  },
};

const HspCurrentResults = (props) => {
  const { classes } = props;
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    if (props.data) {
      setData({
        protection: {
          allOk: {
            total: size(
              filter(props.data, (item) =>
                includes(
                  [88, 106],
                  get(item, ["human", "verification", 0, "instruction_id"])
                )
              )
            ),
          },
          assistance: {
            total: size(
              filter(
                props.data,
                (item) =>
                  get(item, ["human", "verification", 0, "instruction_id"]) &&
                  !includes(
                    [88, 106],
                    get(item, ["human", "verification", 0, "instruction_id"])
                  )
              )
            ),
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.data)]);

  //   const [secondaryDetails, setSecondaryDetails] = React.useState({
  //     open: false,
  //     section: null,
  //     subSection: null,
  //   });

  const doughnutColors = [colors.greenDoughnut, colors.yellowDoughnut];

  //   let filters = props.filters;
  //   if (get(filters, ["header"])) {
  //     filters.header.section = get(secondaryDetails, ["section"]);
  //     filters.header.subsection = get(secondaryDetails, ["subSection"]);
  //   }

  return (
    <DashboardCard
      title={I18n.get("dashboard_questionnaireResults")}
      size={sizes.small}
    >
      {/* <HspQuestionnaireResultsDialog
        open={get(secondaryDetails, ["open"])}
        setOpen={setSecondaryDetails}
        filters={filters}
        subSection={get(secondaryDetails, ["subSection"])}
      /> */}
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100%" }}
      >
        <Grid item className={classes.doughnutContainer}>
          <DashboardDoughnut
            values={[
              get(data, ["protection", "allOk", "total"]),
              get(data, ["protection", "assistance", "total"]),
            ]}
            total={
              get(data, ["protection", "allOk", "total"]) +
              get(data, ["protection", "assistance", "total"])
            }
            colors={doughnutColors}
            // onClick={() =>
            //   setSecondaryDetails({
            //     open: true,
            //     section: "questionnaire",
            //     subSection: "all",
            //   })
            // }
          />
        </Grid>
        <Grid
          item
          style={{ marginLeft: "10px", padding: "0px 14px", minWidth: "160px" }}
        >
          <Grid container direction="column">
            {map(["allOk", "assistance"], (type, index) => (
              <DoughnutLegend
                key={type}
                color={doughnutColors[index]}
                title={I18n.get(`dashboard_${type}`)}
                value={get(data, ["protection", type, "total"])}
                percentage={calculatePercentage(
                  get(data, ["protection", type, "total"]),
                  get(data, ["protection", "allOk", "total"]) +
                    get(data, ["protection", "assistance", "total"])
                )}
                // onClick={() =>
                //   setSecondaryDetails({
                //     open: true,
                //     section: "questionnaire",
                //     subSection: type === "allOk" ? "allok" : "failed",
                //   })
                // }
                tooltip={
                  type === "assistance"
                    ? I18n.get("dashboard_riskTooltip")
                    : null
                }
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </DashboardCard>
  );
};

export default withStyles(styles)(HspCurrentResults);
